import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { formattedNumber } from '../../../../../../utils/formatterHelpers';

const styles = theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '100%',
        flexShrink: 0,
        textTransform: 'capitalize',
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
});

class ACDCSpanels extends React.Component {
  state = {
      expanded: null,
  };

  handleChange = panel => (event, expanded) => {
      this.setState({
          expanded: expanded ? panel : false,
      });
  };

  render() {
      const { classes, terms } = this.props;
      const { expanded } = this.state;
      let building = 'home';
      if (terms.resiToggle === false) {
          building = 'building';
      }

      let grade = null;
      if (terms.projectState === 1) {
          grade = 'D-';
      } else if (terms.projectState === 2 || '4') {
          grade = 'D-';
      } else if (terms.projectState === 3) {
          grade = 'C+';
      } else if (terms.projectState === 5) {
          grade = 'C-';
      }

      let state = null;
      if (terms.projectState === 1) {
          state = 'California';
      } else if (terms.projectState === 2 || '4') {
          state = 'the United States';
      } else if (terms.projectState === 3) {
          state = 'New Jersey';
      } else if (terms.projectState === 5) {
          state = 'Florida';
      }
      const link = <a href="https://www.infrastructurereportcard.org/state-by-state-infrastructure/" target="_blank" rel="noopener noreferrer">In {state}, the electric grid was rated {grade}.</a>;

      return (
          <div className={classes.root}>
              <ExpansionPanel expanded={expanded === 'panel134'} onChange={this.handleChange('panel134')}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography
                          className={classes.heading}
                      >
                          Why Is PV Solar Important?
                      </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                      <Typography className="specsText">
                          <p>
                              Producing energy from your Solvana PV solar-generating system is environmentally friendly, but there are many other reasons for you need to Go Solar. Here are a few reasons we feel using PV solar for your electrical needs is a no-brainer.
                          </p>
                      </Typography>
                  </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel expanded={expanded === 'panel1'} onChange={this.handleChange('panel1')}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography
                          className={classes.heading}
                      >
                          Since 2009 There Has Been a 70% Reduction in PV Solar Prices
                      </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                      <Typography className="specsText">
                          <p>
                              Over the past decade, there has been a 70% reduction in the installed price of PV solar-generating systems. Additionally, Solvana’s Zero-Contact Proposal Tool™ is another one of the ways we reduce costs to bring our customers the best value. Solvana’s digital and interactive Zero-Contact Proposal Tool™ minimizes the number of salespeople, expenses of travel, overhead, and is less intrusive than in-person sales meetings. Solvana’s PV solar and Energy Storage System experts have a combined 25-years of experience in PV solar and 65-years in construction. Solvana’s Energy Matters Simulation™ delivers an analysis that is both honest and intelligent. If you have a question, please ask it, and we will answer it head-on!
                          </p>
                      </Typography>
                  </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel expanded={expanded === 'panel3'} onChange={this.handleChange('panel3')}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography className={classes.heading}>Installing Solar Panels Helps Rebuild America&#39;s Infrastructure</Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                      <Typography className="specsText">
                          <p>
                              Moving electricity generation to where you are consuming it is referred to as decentralized energy generation, which is a practical solution to a relatively unknown challenge currently facing the existing centralized energy generation-based utility grid. One of the most significant challenges facing the electrical utility grid is transmission line loss, which accounts for approximately 15% of centralized energy generated transmitted electricity.
                          </p>
                          <p>
                              Unlike infrastructure roads and bridges, where we can visibly see damage such as potholes and rust, we cannot see the physical destruction suffered by the existing centralized energy generation-based utility grid {link}. And, we can no longer accept an “out of sight, out of mind” mentality about the damage currently suffered by the existing centralized energy generation-based utility grid.
                          </p>

                          <p>
                              A Solvana PV solar-generating system provides you with the simplest way to help fix the electrical utility grid. By decentralizing electrical production, you are significantly reducing the amount of energy that would have needed to be manufactured by a centralized energy generation-based utility grid by avoiding their massive transmission line losses. Decentralized electrical production substantially reduces the amount of stress placed on the transmission segment of our centralized energy generation-based utility grid. Decentralizing electrical production can also save you from the disastrous economic effects caused by brownouts and blackouts, which interfere with your quality of life and pose threats to our national security.
                              {link}
                          </p>

                      </Typography>
                  </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel expanded={expanded === 'panel13'} onChange={this.handleChange('panel13')}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography className={classes.heading}>Buying Electricity in Bulk Saves</Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                      <Typography className="specsText">
                          <p>
                              You have to buy electricity and PV solar is simply a smarter way to do it. Much like shopping at wholesale stores like Costco™ and Sam&apos;s Club™, it pays to buy in bulk, and buying electricity is no different. Years ago, you only had one choice to buy electricity, which was to rent power from your electrical utility grid company every month, in perpetuity. This concept is not rocket science. We need electricity every day of our lives. All-day. Every-day. We have all seen the crazy lines at Costco™ gas stations because we all know the value of a discount; however, on an annual basis, buying Costco™ gas translates to savings of only about $135 per driver per year. PV solar will save you an average of ${formattedNumber(terms.annualResults[30].cumulativeSolarSavings / 30)}/year. To put this into perspective, PV solar benefits you {formattedNumber((terms.annualResults[30].cumulativeSolarSavings / 30) / 135)} times more than buying gas at Costco™, which everyone thinks is a great idea judging by their long lines. So, while they last, take advantage of substantial financial benefits available to you now that can pay for your PV solar. It is natural to ask, &ldquo;why should you buy PV solar?&rdquo; and now that you have the answers to that question, the next one is, &ldquo;why wouldn&apos;t you buy PV solar?&rdquo;
                          </p>
                      </Typography>
                  </ExpansionPanelDetails>
              </ExpansionPanel>
              <ExpansionPanel expanded={expanded === 'panel1334'} onChange={this.handleChange('panel1334')}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                      <Typography className={classes.heading}>Buying vs Renting</Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                  <Typography className="specsText">
                    <p>
                          You own your {building}, but rent your electric. That doesn&#39;t make <em>cents</em>! Buying your {building} made more sense than renting, the same logic applies to your electric. {terms.firstName}, going solar a no-brainer, take the final step to become independent from {terms.provider}.
                      </p>
                  </Typography>
                  </ExpansionPanelDetails>
              </ExpansionPanel>
          </div>
      );
  }
}

ACDCSpanels.propTypes = {
    classes: PropTypes.object.isRequired,
    terms: PropTypes.object.isRequired,
};

export default withStyles(styles)(ACDCSpanels);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/OtherBenefits/OtherBenefitsPanels.js